<div class="cash-advance" #sectionElement>
  <app-container>
    <div class="cash-advance__banner" (click)="onBannerClick()">
      <div class="cash-advance__content">
        <div class="cash-advance__content-left">
          <div class="cash-advance__label">Aprovecha hasta</div>
          <div class="cash-advance__amount">$4.000.000</div>
          <div class="cash-advance__description">Solicitando tu <b>Super Avance</b></div>

          <a
            href="https://api.whatsapp.com/send?phone=56958123297&text=Hola%20Unipay%20%F0%9F%98%80"
            class="cash-advance__button"
          >
            Simular Super Avance
          </a>

          <div class="cash-advance__disclaimer">
            Monto sujeto a evaluación crediticia del cliente al solicitarlo.
          </div>
        </div>
        <div class="cash-advance__content-right">
          <div class="cash-advance__image-container">
            <img
              src="	https://www.unipay.cl/api/descargaArchivo/web-SA_1.gif"
              alt="Familia feliz usando laptop"
              class="cash-advance__image"
            />
          </div>
        </div>
      </div>
    </div>
    <a routerLink="/productos" class="cash-advance__link-mobile">
      <span class="cash-advance__button-content-mobile">

        Conoce mas productos
      </span>
    </a>
  </app-container>

  <!-- Botones flotantes que aparecen al hacer scroll -->
  <div class="cash-advance__floating-buttons" [class.cash-advance__floating-buttons--visible]="isScrolled">
    <button class="cash-advance__floating-button cash-advance__floating-button--primary" (click)="openAutoApertura()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="cash-advance__floating-icon">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
      </svg>
      <span class="cash-advance__floating-text">Solicitar Unipay</span>
    </button>

    <button class="cash-advance__floating-button cash-advance__floating-button--secondary" (click)="openPagoEstadoCuenta()">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" stroke="currentColor" class="cash-advance__floating-icon">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
      </svg>
      <span class="cash-advance__floating-text">Pagar estado cuenta</span>
    </button>
  </div>
</div>
